import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NavMobileState {
  isMobile: boolean;
  isNavOpen: boolean;
}

const initialState: NavMobileState = {
  isMobile: false,
  isNavOpen: false
};

export const navMobileSlice = createSlice({
  name: "navMobile",
  initialState,
  reducers: {
    setIsMobile: (state, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload;
    },
    toggleNav: (state) => {
      state.isNavOpen = !state.isNavOpen;
    },
    closeNav: (state) => {
      state.isNavOpen = false;
    }
  }
});

export const { setIsMobile, toggleNav, closeNav } = navMobileSlice.actions;
export default navMobileSlice.reducer;
